import TrailerContent from "./TrailerContent";

export default TrailerContent